module.exports = __webpack_public_path__ + "static/media/delete-white.192a2091.svg";